export default __webpack_public_path__ + "static/media/eunice.d84292b4.jpg";